import { render, staticRenderFns } from "./customDashboardList.vue?vue&type=template&id=1d0bedac&scoped=true"
import script from "./customDashboardList.vue?vue&type=script&lang=js"
export * from "./customDashboardList.vue?vue&type=script&lang=js"
import style0 from "./customDashboardList.vue?vue&type=style&index=0&id=1d0bedac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0bedac",
  null
  
)

export default component.exports